import { z } from "zod";

import { ReOnboardingRequestInputSchema } from "@/lib/zod/__generated__/validation-schema";

import type { ZodError } from "zod";

const ERROR_MESSAGES = {
	validFreeText_min: "自由記入欄は必須項目です",
	validFreeText_max: "自由記入欄は1000文字以内で入力してください",
};

/**
 *
 * @description 再オンボーディング通知用のバリデーションスキーマ
 */
export const ReOnboardingRequestInputZodSchema = ReOnboardingRequestInputSchema.extend({
	message: z.string().min(1, ERROR_MESSAGES.validFreeText_min).max(1000, ERROR_MESSAGES.validFreeText_max),
	updatedEmail: z.string().email(),
});

export type ReOnboardingRequestInputZodSchemaType = z.infer<typeof ReOnboardingRequestInputZodSchema>;

export type ReOnboardingRequestInputZodParseError = ZodError<ReOnboardingRequestInputZodSchemaType>;
